import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportOrderIdView, ShipmentCommentsModel } from '../../../../models';
import { ShipmentTransportOrderEndpoint } from '../../constants/shipment-transport-order-endpoint';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderCommentsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderComments(transportOrderIdView: TransportOrderIdView): Observable<ShipmentCommentsModel[]> {
    const url = `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.TranportOrders}${
      ShipmentTransportOrderEndpoint.Comments
    }?${getQueryStringFromObject({
      ...transportOrderIdView,
    })}`;

    return this.http.withLoading().get(url);
  }

  saveShipmentTransportOrderComment(
    transportOrderIdView: TransportOrderIdView,
    comment: string,
  ): Observable<ShipmentCommentsModel> {
    return this.http
      .withLoading()
      .post(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.TranportOrders}${ShipmentTransportOrderEndpoint.Comments}`,
        {
          transportOrder: transportOrderIdView,
          comment,
        },
      );
  }
}
